import { render, staticRenderFns } from "./indexServicer.vue?vue&type=template&id=c5b0a8e2&"
import script from "./indexServicer.vue?vue&type=script&lang=ts&"
export * from "./indexServicer.vue?vue&type=script&lang=ts&"
import style0 from "./indexServicer.vue?vue&type=style&index=0&id=c5b0a8e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports